// extracted by mini-css-extract-plugin
module.exports = {"BreadcrumbTitle":"Breadcrumbs_BreadcrumbTitle__ZGpAK","Dot":"Breadcrumbs_Dot__gHN_I"};